export default __webpack_public_path__ + "static/media/payment-nav.0190089a.svg";